// extracted by mini-css-extract-plugin
export default {"title":"CurrentInsurance_title__KTpAk","description":"CurrentInsurance_description__je84y","link":"CurrentInsurance_link__-e9fR"};